import { buildModelManager } from "../builder.js";
const DefaultPh4456EvaluationSelection = {
  __typename: true,
  id: true,
  airwayPatency: true,
  breathingAdequacy: true,
  bsiPrecautions: true,
  chiefComplaint: true,
  circulationAssessment: true,
  cohortId: true,
  comments: true,
  completionTime: true,
  createdAt: true,
  createdById: true,
  criticalFailures: true,
  diagnosticTools: true,
  emailedToStudent: true,
  evaluationDate: true,
  evaluationMetadata: true,
  formVersion: true,
  generalImpression: true,
  historyPresent: true,
  instructorEmail: true,
  instructorId: true,
  interventionRepeated: true,
  levelOfConsciousness: true,
  mechanismOfInjury: true,
  needForResources: true,
  numberOfPatients: true,
  opqrst: true,
  overallScore: true,
  pertinentNegatives: true,
  pertinentPositives: true,
  physicalExam: true,
  priorityDecision: true,
  sample: true,
  scenarioId: true,
  scenarioRunId: true,
  sceneHazards: true,
  sceneSize: true,
  shareTokenId: true,
  simulationSessionId: true,
  status: true,
  studentEmail: true,
  studentId: true,
  submittedViaEmail: true,
  updatedAt: true,
  vitalSigns: true,
  vitalSignsTrend: true
};
const modelApiIdentifier = "ph4456Evaluation";
const pluralModelApiIdentifier = "ph4456Evaluations";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPh4456EvaluationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPh4456Evaluation",
    operationReturnType: "CreatePh4456Evaluation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      ph4456Evaluation: { required: false, type: "CreatePh4456EvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePh4456Evaluations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePh4456EvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "updatePh4456Evaluation",
    operationReturnType: "UpdatePh4456Evaluation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      ph4456Evaluation: { required: false, type: "UpdatePh4456EvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePh4456Evaluations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePh4456EvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "deletePh4456Evaluation",
    operationReturnType: "DeletePh4456Evaluation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePh4456Evaluations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "submitPh4456Evaluation",
    operationReturnType: "SubmitPh4456Evaluation",
    functionName: "submit",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      ph4456Evaluation: { required: false, type: "SubmitPh4456EvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkSubmitPh4456Evaluations",
    functionName: "bulkSubmit",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "submit",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSubmitPh4456EvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "upsertPh4456Evaluation",
    operationReturnType: "UpsertPh4456Evaluation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      ph4456Evaluation: { required: false, type: "UpsertPh4456EvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePh4456EvaluationResult": { hasReturnType: false },
      "... on UpdatePh4456EvaluationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPh4456Evaluations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPh4456EvaluationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPh4456EvaluationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "ph4456EvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const Ph4456EvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPh4456EvaluationSelection,
  operations
);
export {
  DefaultPh4456EvaluationSelection,
  Ph4456EvaluationManager
};
//# sourceMappingURL=Ph4456Evaluation.js.map
